//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,athena: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const athenaResultset = data['athenaResultset']
    formData.isInvalidDoc = athenaResultset['is_invalid_doc']?athenaResultset['is_invalid_doc']:false
    formData.isOverrideVendorName = athenaResultset['is_override_vendor_name']?athenaResultset['is_override_vendor_name']:false
    formData.isOverrideTotal = athenaResultset['is_override_total']?athenaResultset['is_override_total']:false
    
    if (athenaResultset['inv_no']){
        formData.invNo = athenaResultset['inv_no']
    }
    if (athenaResultset['inv_date']){
        formData.invDate = athenaResultset['inv_date']
    }
    if (athenaResultset['booking_no']){
        formData.bookingNo = athenaResultset['booking_no']
    }
    if (athenaResultset['reference_no']){
        formData.referenceNo = athenaResultset['reference_no']
    }
    if (athenaResultset['total']){
        formData.total = parseFloat(athenaResultset['total'])
    }
    if (athenaResultset['vendor_name']){
        formData.vendorName = athenaResultset['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/athena/editFormData.js